import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/controlles.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_ControlsDialog = _resolveComponent("ControlsDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      class: "badge-danger btn tw-controller-trigger-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleShowControls())),
      floating: ""
    }, {
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)),
        (_ctx.controls > 0)
          ? (_openBlock(), _createBlock(_component_q_badge, {
              key: 0,
              color: "red",
              floating: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.controls), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ControlsDialog)
  ], 64))
}